module.exports = __webpack_public_path__ + "267b88e4045b378b88f5203ea01a65c0.svg";